import { EXPORT_PAGES, FAQ_ITEMS, SHIPPING_DETAIL } from './pageContent';

const MAX_CONTEXT_LENGTH = 5500;

const exportPageContext = (page, complianceMap) => {
  const compliance = complianceMap?.[page.slug] || page.compliance;
  const faqText = page.faq.map((f) => `Q: ${f.q}\nA: ${f.a}`).join('\n');
  const complianceText = compliance ? `${compliance.heading}: ${compliance.body.join(' ')}` : '';
  return [
    `Current page: Export destination — ${page.navLabel}${page.port ? ` (Port of ${page.port})` : ''}.`,
    page.intro,
    complianceText,
    'FAQs for this page:',
    faqText,
  ].filter(Boolean).join('\n\n');
};

const exportHubContext = (complianceMap) => {
  const countries = EXPORT_PAGES.filter((p) => p.type === 'country' && !p.draft);
  const summary = countries
    .map((p) => {
      const compliance = complianceMap?.[p.slug] || p.compliance;
      return `${p.navLabel} (${p.port || 'domestic'}): ${compliance?.alert ? 'RESTRICTED — ' : 'Generally permitted — '}${compliance?.body?.[0] || ''}`;
    })
    .join('\n');
  return `Current page: Export Destinations Hub — lists every country we ship bulk used tires to.\n\n${summary}`;
};

const generalSiteContext = () => {
  const faqText = FAQ_ITEMS.slice(0, 6).map((f) => `Q: ${f.q}\nA: ${f.a}`).join('\n');
  const countries = EXPORT_PAGES.filter((p) => p.type === 'country' && !p.draft).map((p) => p.navLabel).join(', ');
  const shippingText = SHIPPING_DETAIL.steps.map((s) => `${s.title}: ${s.body}`).join('\n');
  return [
    'Current page: general BulkUsedTires.com page (not a specific export destination page).',
    `We currently export bulk used tires to: ${countries}, plus domestic USA wholesale, sourced from our USA warehouse and our partner suppliers in Germany.`,
    'General FAQs:',
    faqText,
    'Shipping process:',
    shippingText,
  ].join('\n\n');
};

export const buildPageContext = (pathname, complianceMap) => {
  if (pathname.startsWith('/export/')) {
    const slug = pathname.split('/')[2];
    const page = EXPORT_PAGES.find((p) => p.slug === slug);
    if (page) return exportPageContext(page, complianceMap).slice(0, MAX_CONTEXT_LENGTH);
  }
  if (pathname === '/export') return exportHubContext(complianceMap).slice(0, MAX_CONTEXT_LENGTH);
  return generalSiteContext().slice(0, MAX_CONTEXT_LENGTH);
};
